import React, { useState } from "react";

const ServiceList = ({ order }) => {
  return (
    <div className="col-md-4">
      <div className="card p-4 mb-3">
        <div className="row">
          <div className="col-md-6">
            <img
              src={`data:image/png;base64,${order.image.img}`}
              className="img-fluid m-auto service-img float-left"
              alt="..."
            />
          </div>
          <div className="col-md-6">
            {order.status === null && (
              <button className="btn alert-warning float-right">
                On going
              </button>
            )}
            {order.status === undefined && (
              <button className="btn alert-warning float-right">
                On going
              </button>
            )}
            {order.status === "Pending" && (
              <button className="btn alert-danger float-right">Pending</button>
            )}
            {order.status === "Ongoing" && (
              <button className="btn alert-warning float-right">Ongoing</button>
            )}
            {order.status === "Done" && (
              <button className="btn alert-success float-right">Done</button>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div style={{ color: "black" }} className="card-body">
              <h5 className="card-title">{order.project}</h5>
              <p className="card-text">{order.projectDetails}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceList;

//  ) : (
//               <button
//                 className={`${
//                   (order.status === "Pending" && "alert-danger") ||
//                   (order.status === "Ongoing" && "alert-warning") ||
//                   (order.status === "Done" && "alert-success")
//                 } btn float-right`}
//               >
//                 {order.status}
//               </button>
//             )
